import { Link } from 'react-router';
import { useMeta } from '@/client/lib/useMeta';
import { FramedImage } from '@/components/FramedImage';
import { useI18n } from '@/client/i18n/I18nContext';
import { lp } from '@/client/i18n/locale';

export function NotFoundPage() {
  const { t } = useI18n();
  useMeta({ title: t('meta.notFound.title'), path: '/404', noindex: true });
  return (
    <div className="container">
      <div className="state">
        <div
          className="casa-card__media"
          style={{ aspectRatio: '1', maxWidth: 200, margin: '0 auto var(--space-5)' }}
        >
          <FramedImage src="/media/caro/carolina-collaer-caro-casa-de-estilo-retrato.webp" alt="CARO. Casa de estilo" fallback="CARO" />
        </div>
        <p className="eyebrow">{t('notfound.eyebrow')}</p>
        <h1 className="section-title">{t('notfound.title')}</h1>
        <p>{t('notfound.body')}</p>
        <div className="mt-6" style={{ display: 'flex', gap: 'var(--space-3)', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link className="btn" to={lp('/')}>{t('common.home')}</Link>
          <Link className="btn btn--ghost" to={lp('/shop/beauty')}>{t('nav.beauty')}</Link>
        </div>
      </div>
    </div>
  );
}
